/**
 * Pluralize a word based on the amount of the thing the word describes.
 *
 * @param {string} singular - The word in singular form.
 * @param {number} amount - The number of things represented by word, to determine whether to pluralize.
 * @param {string} [override] - The word in plural form. If omitted, assumed to be singular with a "s" appended to it.
 * @returns {JSX.Element}
 */
export const pluralize = (singular, amount, override) => {
  if (amount == 1) return singular;

  if (override) {
    return override;
  }
  return `${singular}s`;
};

/**
 *
 * @param {object} duration
 * @param {string} duration.unit - The interval unit, e.g. 'week', 'month', etc.
 * @param {number} duration.value - The interval value.
 * @returns {string} - A duration phrase, e.g. "per week" or "for 6 months" for the given unit and value.
 */
export const offerDurationInterval = ({ unit, value }) => {
  return [
    value === 1 ? 'per' : 'for',
    value === 1 ? '' : value,
    pluralize(unit, value),
  ]
    .filter(Boolean)
    .join(' ');
};

const DURATION_UNITS = {
  day: 'Daily',
  month: 'Monthly',
  week: 'Weekly',
  year: 'Yearly',
};

/**
 *
 * @param {object} duration
 * @param {string} duration.unit - The interval unit, e.g. 'week', 'month', etc.
 * @param {number} duration.value - The interval value.
 * @returns {string} - A recurring duration phrase, e.g. "every 6 months", "monthly", etc., for the given unit and value.
 */
export const recurringDurationInterval = ({ unit, value = 1 }) => {
  return Number(value) === 1
    ? DURATION_UNITS[unit] || unit // e.g. 'Daily'
    : `every ${value} ${pluralize(unit)}`; // e.g. "every 6 months"
};
